import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 800);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!show) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="Powrót do góry"
      className="fixed bottom-24 md:bottom-28 right-4 md:right-8 z-40 w-10 h-10 rounded-full bg-foreground-900/80 text-white flex items-center justify-center shadow-lg hover:bg-foreground-950 hover:scale-110 active:scale-95 transition-all duration-300 cursor-pointer"
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}